(()=>{'use strict';
const CHARTS={
  'regular-men':{chest:[51,53.5,56,59],ease:12},
  'regular-women':{chest:[46,48,50,52],ease:9},
  'semi':{chest:[56,58,60,62],ease:19},
  'oversize':{chest:[57,59.5,62.5,65.5],ease:24},
  'hoodie':{chest:[60.5,63,66,69],ease:29},
  'jacket':{chest:[60,62,65,69],ease:26}
};
const ORDER=['S','M','L','XL'];
function init(root){
 if(root.dataset.ubSfReady==='1')return;
 root.dataset.ubSfReady='1';
 const form=root.querySelector('.ub-sf__form'),output=root.querySelector('.ub-sf__result');
 if(!form||!output)return;
 const en=root.dataset.lang==='en';
 const msg=(es,english)=>en?english:es;
 const offered=Array.from(root.querySelectorAll('[data-ub-sf-size]')).map(el=>({size:String(el.dataset.ubSfSize||'').trim().toUpperCase(),available:el.dataset.ubSfAvailable==='true'}));
 form.addEventListener('submit',ev=>{
  ev.preventDefault();
  const h=Number(form.elements.height.value),w=Number(form.elements.weight.value),c=form.elements.chest.value.trim()===''?null:Number(form.elements.chest.value);
  if(!Number.isFinite(h)||!Number.isFinite(w)||h<135||h>215||w<35||w>200||(c!==null&&(!Number.isFinite(c)||c<60||c>160))){
    output.hidden=false;output.textContent=msg('Revisa los valores de estatura, peso y pecho.','Please review your height, weight, and chest values.');return;
  }
  const chart=CHARTS[root.dataset.fit];
  if(!chart)return;
  const gender=form.elements.gender.value,preference=form.elements.preference.value;
  let idx=1;
  let method='approx';
  if(c!==null){
   const ease=chart.ease+(preference==='fitted'?-5:preference==='relaxed'?5:0);
   const deviations=chart.chest.map(half=>Math.abs(half*2-c-ease));
   idx=deviations.indexOf(Math.min(...deviations));
   method='measurement';
  }else{
   // Provisional heuristic; not a body-measurement prediction or fitted model.
   const adj=gender==='mujer'?w*Math.pow(165/h,1.4):w*Math.pow(175/h,1.4);
   const t=gender==='mujer'?[52,65,77]:[63,78,94];
   idx=adj<t[0]?0:adj<t[1]?1:adj<t[2]?2:3;
   if(preference==='fitted')idx=Math.max(0,idx-1);
   if(preference==='relaxed')idx=Math.min(3,idx+1);
  }
  const size=ORDER[idx],present=offered.some(item=>item.size===size),available=offered.some(item=>item.size===size&&item.available);
  const small=method==='measurement'?msg('Estimación basada en tu contorno de pecho y nuestra tabla general de la prenda.','Estimate based on your chest measurement and our general garment chart.'):msg('Estimación aproximada según estatura, peso, patronaje y preferencia de fit.','Approximate estimate from height, weight, sizing profile, and fit preference.');
  const title=msg('TU TALLA ORIENTATIVA','YOUR ESTIMATED SIZE');
  const availability=!present?msg('Esta talla no figura entre las variantes de esta referencia.','This size is not offered for this product.'):!available?msg('Esta talla aparece agotada en este momento.','This size is currently sold out.'):msg('Comprueba la talla en el selector antes de añadir al carrito.','Check the size selector before adding to cart.');
  const heightNote=h>=189?msg('Por tu estatura, verifica especialmente el largo de la prenda.','Because of your height, check the garment length carefully.'):'';
  output.replaceChildren();
  const heading=document.createElement('span');heading.textContent=title;output.appendChild(heading);
  const big=document.createElement('strong');big.textContent=size;output.appendChild(big);
  const desc=document.createElement('p');desc.textContent=small;output.appendChild(desc);
  const note=document.createElement('small');note.textContent=availability;output.appendChild(note);
  if(heightNote){const more=document.createElement('small');more.textContent=heightNote;output.appendChild(more);}
  output.hidden=false;
 });
}
function start(){document.querySelectorAll('[data-ub-size-finder]').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
document.addEventListener('shopify:section:load',start);
})();